import { Routes } from '@angular/router';

import { MaintenanceGuard } from '@core/guards/public/maintenance.guard';

export const PUBLIC_ROUTES: Routes = [
  {
    path: 'landing',
    loadChildren: async (): Promise<Routes> =>
      (await import('./modules/landing/landing.routes')).LANDING_ROUTES
  },
  {
    path: 'verification-landing',
    loadChildren: async (): Promise<Routes> =>
      (
        await import('./modules/verification-landing/verification-landing.routes')
      ).VERIFICATION_LANDING_ROUTES
  },
  {
    path: 'login',
    loadChildren: async (): Promise<Routes> =>
      (await import('./modules/login/login.routes')).LOGIN_ROUTES
  },
  {
    path: 'action',
    loadChildren: async (): Promise<Routes> =>
      (await import('./modules/action/action.routes')).ACTIONS_ROUTES
  },
  {
    path: 'cookies-policy',
    loadChildren: async (): Promise<Routes> =>
      (await import('./modules/cookies-policy/cookies-policy.routes'))
        .COOKIES_POLICY_ROUTES
  },
  {
    path: 'login/:name',
    loadChildren: async (): Promise<Routes> =>
      (await import('./modules/custom-login/custom-login.routes'))
        .CUSTOM_LOGIN_ROUTES
  },
  {
    path: 'enterprise-login',
    loadChildren: async (): Promise<Routes> =>
      (await import('./modules/enterprise-login/enterprise-login.routes'))
        .ENTERPRISE_LOGIN_ROUTES
  },
  {
    path: 'legal-conditions',
    loadChildren: async (): Promise<Routes> =>
      (await import('./modules/legal-conditions/legal-conditions.routes'))
        .LEGAL_CONDITIONS_ROUTES
  },
  {
    path: 'maintenance',
    loadChildren: async (): Promise<Routes> =>
      (await import('./modules/maintenance/maintenance.routes'))
        .MAINTENANCE_ROUTES,
    canLoad: [MaintenanceGuard]
  },
  {
    path: 'not-found',
    loadChildren: async (): Promise<Routes> =>
      (await import('./modules/not-found/not-found.routes')).NOT_FOUND_ROUTES
  },
  {
    path: 'payment-cancelled',
    loadChildren: async (): Promise<Routes> =>
      (await import('./modules/payment-cancelled/payment-cancelled.routes'))
        .PAYMENT_CANCELLED_ROUTES
  },
  {
    path: 'payment-success',
    loadChildren: async (): Promise<Routes> =>
      (await import('./modules/payment-success/payment-success.routes'))
        .PAYMENT_SUCCESS_ROUTES
  },
  {
    path: 'privacy-policy',
    loadChildren: async (): Promise<Routes> =>
      (await import('./modules/privacy-policy/privacy-policy.routes'))
        .PRIVACY_POLICY_ROUTES
  },
  {
    path: 'register',
    loadChildren: async (): Promise<Routes> =>
      (await import('./modules/register-user/register-user.routes'))
        .REGISTER_USER_ROUTES
  },
  {
    path: 'stripe-account-ko',
    loadChildren: async (): Promise<Routes> =>
      (await import('./modules/stripe-account-ko/stripe-account-ko.routes'))
        .STRIPE_ACCOUNT_KO_ROUTES
  },
  {
    path: 'stripe-account-ok',
    loadChildren: async (): Promise<Routes> =>
      (await import('./modules/stripe-account-ok/stripe-account-ok.routes'))
        .STRIPE_ACCOUNT_OK_ROUTES
  },
  {
    path: 'success-page',
    loadChildren: async (): Promise<Routes> =>
      (await import('./modules/success/success.routes')).SUCCESS_ROUTES
  },
  {
    path: 'documentation-permissions',
    loadChildren: async (): Promise<Routes> =>
      (
        await import('./modules/user-registry-certification/user-registry-certification.routes')
      ).USER_REGISTRY_CERTIFICATION_ROUTES
  },
  {
    path: 'ebi-club/login',
    loadChildren: async (): Promise<Routes> =>
      (await import('./modules/ebi-club-login/ebi-club-login.routes'))
        .EBI_CLUB_LOGIN_ROUTES
  },
  {
    path: 'public/insurance/:token',
    loadChildren: async (): Promise<Routes> =>
      (
        await import(
          './modules/public-insurance-form/public-insurance-form.routes'
        )
      ).PUBLIC_INSURANCE_FORM_ROUTES
  }
];
